module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/venue_eight-4289cc390f96cb8a22624c9d5691a72a.jpg";